<div class="row">
  <div class="col-12 no-margin">
    <mat-tab-group mat-align-tabs="start" [(selectedIndex)]="selectedTabIndex">
      <mat-tab label="Additional Charges"></mat-tab>
      <mat-tab label="Invoice Reference"></mat-tab>
    </mat-tab-group>
  </div>

  <div [style.display]="selectedTabIndex == 0 ? 'block' : 'none'">
    <addtional-charges
      [setData]="additionalCharges"
      [mawb]="mawb"
      [isClosed]="isClosed"
      *ngIf="hasChargesConfig"></addtional-charges>
  </div>

  <div [style.display]="selectedTabIndex == 1 ? 'block' : 'none'">
    <invoice-reference
      [setData]="invoiceReference"
      [mawb]="mawb"
      [isClosed]="isClosed"></invoice-reference>
  </div>
</div>
